import { Box, Grid, Paper, Skeleton, Stack } from "@mui/material";
import { SubmissionStatus } from "generated-graphql/graphql";
import { Suspense } from "react";
import { SubmissionGeneratorStatusContent } from "./SubmissionGeneratorStatusTile";
import { SubmissionStateContent } from "./SubmissionStateTile";
import { SubmissionStatusContent } from "./SubmissionStatusTile";
import {
  WasteSubmissionsOverviewProvider,
  WasteSubmissionsOverviewFilter,
} from "./WasteSubmissionsOverviewContext";

type SubmissionStatsOverviewProps = {
  onStatusClick?: (status: SubmissionStatus) => void;
  selectedStatus?: SubmissionStatus | null;
  onStateClick?: (state: string) => void;
  selectedState?: string | null;
  onGeneratorStatusClick?: (status: string) => void;
  selectedGeneratorStatus?: string | null;
  /**
   * Filter to apply to the overview charts.
   * When provided, charts will reflect the same filters as the data grid.
   * This allows the charts to stay in sync with omnisearch, top filter bar,
   * and URL filter changes.
   */
  filter?: WasteSubmissionsOverviewFilter;
};

function StatsSkeleton() {
  return (
    <Paper elevation={0}>
      <Box sx={{ p: 3 }}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Skeleton variant="rounded" height={280} />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Skeleton variant="rounded" height={280} />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Skeleton variant="rounded" height={280} />
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}

export function SubmissionStatsOverview({
  onStatusClick,
  selectedStatus,
  onStateClick,
  selectedState,
  onGeneratorStatusClick,
  selectedGeneratorStatus,
  filter,
}: SubmissionStatsOverviewProps) {
  return (
    <Suspense fallback={<StatsSkeleton />}>
      <WasteSubmissionsOverviewProvider filter={filter}>
        <Paper elevation={0}>
          <Box sx={{ p: 3 }}>
            <Grid container spacing={3}>
              {/* Status donut, Generator Status donut, State bar chart */}
              <Grid size={{ xs: 12, md: 4 }}>
                <Stack spacing={2} sx={{ height: "100%" }}>
                  <SubmissionStatusContent
                    onStatusClick={onStatusClick}
                    selectedStatus={selectedStatus}
                  />
                </Stack>
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <Stack spacing={2} sx={{ height: "100%" }}>
                  <SubmissionGeneratorStatusContent
                    onGeneratorStatusClick={onGeneratorStatusClick}
                    selectedGeneratorStatus={selectedGeneratorStatus}
                  />
                </Stack>
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <Stack spacing={2} sx={{ height: "100%" }}>
                  <SubmissionStateContent
                    onStateClick={onStateClick}
                    selectedState={selectedState}
                  />
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </WasteSubmissionsOverviewProvider>
    </Suspense>
  );
}

export { SubmissionGeneratorStatusTile } from "./SubmissionGeneratorStatusTile";
export { SubmissionStateTile } from "./SubmissionStateTile";
export { SubmissionStatusTile } from "./SubmissionStatusTile";
